import { EventMeta } from '../../../interfaces/meta.interface';
import { riskyFolders, riskyWords } from '../../utils/riskWords';
import { isSuspiciousRuleName } from '../../utils/suspiciousNames';
import { getInboxRuleClx, getParam } from './New-InboxRule';

type InboxRuleFields = {
    /**
     * Whether the rule forwards or redirects mail anywhere (ForwardTo, RedirectTo or ForwardAsAttachmentTo).
     * A boolean, because the classifications match it against `[true]`: until KRAK-406 (2026-10-10) the
     * extractor stored the destination address here, `[true].includes('<address>')` was false for every
     * rule, and no forwarding classification could ever match — a forward-to-external rule graded Info.
     * The addresses themselves are the three fields below.
     */
    forwarding_set: boolean;
    move_item: boolean;
    forward_to: string | undefined;
    redirect_to: string | undefined;
    forward_as_attachment_to: string | undefined;
    move_to_folder: string | undefined;
    org: string | undefined;
    risky_folders: boolean;
    risky_keywords: boolean;
    suspicious_name: boolean;
};

const SetInboxRule: EventMeta<InboxRuleFields> = {
    
    title: 'Inbox Rule Created/Modified',
    default: {
        
        description: 'Inbox Rule Created/Modified',
        longDescription: 'An inbox rule has been created/modified.',
        severity: 'info',
    },
    fieldsExtractor: (log: any) => {
        const forward_to = getParam(log, 'ForwardTo');
        const redirect_to = getParam(log, 'RedirectTo');
        const forward_as_attachment_to = getParam(log, 'ForwardAsAttachmentTo');
        const move_to_folder = getParam(log, 'MoveToFolder');
        const subjectContainWords = getParam(log, 'SubjectContainsWords');
        const ruleName = getParam(log, 'Name');
        return {
            forwarding_set: !!(forward_to || redirect_to || forward_as_attachment_to),
            move_item: move_to_folder ? true : false,
            forward_to,
            redirect_to,
            forward_as_attachment_to,
            move_to_folder,
            org: log.OrganizationName,
            risky_folders: !!move_to_folder
                ? riskyFolders.some((f) => move_to_folder.toLowerCase().includes(f))
                : false,
            risky_keywords: !!subjectContainWords
                ? riskyWords.some((w) => subjectContainWords.toLowerCase().includes(w))
                : false,
            suspicious_name: ruleName ? isSuspiciousRuleName(ruleName) : false,
        };
    },
    classifications: getInboxRuleClx('updated'),
};

export default SetInboxRule;
